export const setInspection = async (context, inspection) => {
  context.commit('SET_INSPECTION', inspection)
}

// export const setInspectiontes = async (context, id) => {
//   // const result = await inspection.get(id)
//   context.commit('SET_INSPECTION', result.data)
// }
